module.exports = __webpack_public_path__ + "img/shop_question_prize@2x.6ffbda88.png";